module.exports = __webpack_public_path__ + "img/volume-up.c2cc50ac.svg";